<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Scanner Error Log" active>

                                <b-row v-if="hasFailedDataScannerErrorLog">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedScannerErrorLog.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="scannerErrorLogsFailed" :fields="fieldsScannerErrorLog" :busy="isDataLoading"
                                                         :sort-by.sync="sortByScannerErrorLog" :sort-desc.sync="sortDescScannerErrorLog" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(logDate)="row">
													{{ row.item.logDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>
												<template #cell(transactionId)="row">
													{{ Number(row.item.transactionId).toLocaleString() }}
												</template>
												<template #cell(inputTypeId)="row">
													{{ Number(row.item.inputTypeId).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedScannerErrorLog.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="scannerErrorLogs" :fields="fieldsScannerErrorLog" :busy="isDataLoading"
                                                         :sort-by.sync="sortByScannerErrorLog" :sort-desc.sync="sortDescScannerErrorLog" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(logDate)="row">
													{{ row.item.logDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>
												<template #cell(transactionId)="row">
													{{ Number(row.item.transactionId).toLocaleString() }}
												</template>
												<template #cell(inputTypeId)="row">
													{{ Number(row.item.inputTypeId).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ScannerErrorLog from '@/models/ScannerErrorLog/ScannerErrorLog';
import ScannerErrorLogList from '@/models/ScannerErrorLog/ScannerErrorLogList';
import ScannerErrorLogFilter from '@/filters/ScannerErrorLog/ScannerErrorLogFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsScannerErrorLog: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Log Date", key: 'logDate', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'customerCode', sortable: false},
				{"class" : "th-status", "label" : "Case Qty", key: 'caseQty', sortable: false},
				{"class" : "th-status", "label" : "Transaction Type", key: 'transactionType', sortable: false},
				{"class" : "th-status", "label" : "Transaction Id", key: 'transactionId', sortable: false},
				{"class" : "th-status", "label" : "Pic", key: 'userFirstName', sortable: false},
				{"class" : "th-status", "label" : "ErrMessage", key: 'errMessage', sortable: false},
				{"class" : "th-status", "label" : "Input Type", key: 'inputType', sortable: false},
				{"class" : "th-status", "label" : "Input Type Id", key: 'inputTypeId', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			scannerErrorLogs : [],
			scannerErrorLogsFailed: [],
			scannerErrorLogId : '',
			sortByScannerErrorLog: '',
			sortDescScannerErrorLog: '',
			hasFailedDataScannerErrorLog: false,
			totalFailedScannerErrorLog: 0,
			totalSucceedScannerErrorLog: 0,

			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('scannererrorlog/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('scannererrorlog/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getScannerErrorLogForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getScannerErrorLogForUpload : async function() {
			let _this = this;
			this.$http.get('scannererrorlog/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.scannerErrorLogs = [];


					if (response != null) {
						let result = response.data;
						_this.scannerErrorLogs = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedScannerErrorLog = _this.scannerErrorLogs.length;

						_this.scannerErrorLogsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataScannerErrorLog = true;
						_this.totalFailedScannerErrorLog = 0;
						if(_this.scannerErrorLogsFailed == undefined || _this.scannerErrorLogsFailed.length === 0) _this.hasFailedDataScannerErrorLog = false;
						if(_this.hasFailedDataScannerErrorLog) _this.totalFailedScannerErrorLog = _this.scannerErrorLogsFailed.length;

						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'scannererrorlog/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ScannerErrorLog.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterScannerErrorLog = new ScannerErrorLogFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
